export default "__VITE_ASSET__BbGONEdz__"